export const headerLinksTexts = {
    benchmark: "activation.home.header.links.benchmark",
    topics: "activation.home.header.links.topics",
    alerts: "activation.home.header.links.alerts",
    title: "activation.home.header.links.title",
};
